<template>
  <div
    class="c-select-options__item"
    :class="{ 'is-selected': isSelected }"
    @click="change"
  >
    <slot>{{ option.label }}</slot>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    option: {
      type: Object,
      required: false,
      default() {
        return {
          label: '',
          value: ''
        };
      }
    },
    selected: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    isSelected() {
      return this.option.value && this.option.value === this.selected;
    }
  },
  methods: {
    change() {
      this.$emit('change', this.option.value);
    }
  }
};
</script>
